import React from "react";
import { ITenant } from "components/tenants/types";

interface CompanyInfoTabProps {
  tenant: ITenant;
  onEdit: () => void;
}

const CompanyInfoTab: React.FC<CompanyInfoTabProps> = ({ tenant, onEdit }) => (
  <div className="p-3 border rounded shadow-sm bg-white">
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h5 className="mb-0">Customer Information</h5>
      <button type="button" className="btn btn-sm btn-primary" onClick={onEdit}>
        Edit
      </button>
    </div>
    <div className="row gy-3">
      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">Customer Name:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.name || "-"}</p>
      </div>

      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">Address:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.address || "-"}</p>
      </div>

      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">City:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.city || "-"}</p>
      </div>

      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">State:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.state || "-"}</p>
      </div>

      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">ZIP:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.zip || "-"}</p>
      </div>

      <div className="col-5 col-lg-2">
        <p className="fw-bold mb-0">Country:</p>
      </div>
      <div className="col-7 col-lg-10 text-lg-start text-end">
        <p className="mb-0">{tenant.companyInfo?.country || "-"}</p>
      </div>
    </div>
  </div>
);

export default CompanyInfoTab;
